/* ==========================================================================
   MobiSpaw — Consolidated Shopify JavaScript
   All interactive behaviors: menus, dropdowns, accordions, carousels
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {

  /* ========================================================================
     Mobile Menu Toggle
     ======================================================================== */
  const mobileToggle = document.getElementById('mobile-menu-toggle');
  const slideOverlay = document.getElementById('slide-menu-overlay');
  const slideCloseMobile = document.getElementById('slide-menu-close-mobile');
  const slideCloseTablet = document.getElementById('slide-menu-close-tablet');
  const slideBackdrop = document.getElementById('slide-menu-backdrop');

  var savedScrollY = 0;

  function openSlideMenu() {
    if (slideOverlay) {
      savedScrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + savedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.overflow = 'hidden';
      slideOverlay.style.display = 'block';
    }
  }
  function closeSlideMenu() {
    if (slideOverlay) {
      slideOverlay.style.display = 'none';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';
      window.scrollTo(0, savedScrollY);
    }
  }

  if (mobileToggle) {
    mobileToggle.addEventListener('click', openSlideMenu);
  }
  if (slideCloseMobile) {
    slideCloseMobile.addEventListener('click', closeSlideMenu);
  }
  if (slideCloseTablet) {
    slideCloseTablet.addEventListener('click', closeSlideMenu);
  }
  if (slideBackdrop) {
    slideBackdrop.addEventListener('click', closeSlideMenu);
  }

  /* ========================================================================
     Desktop Locations Dropdown (hover)
     ======================================================================== */
  const locationsDropdown = document.querySelector('.locations-dropdown');
  if (locationsDropdown) {
    const trigger = locationsDropdown.querySelector('.locations-trigger');
    const menu = locationsDropdown.querySelector('.locations-menu');
    if (trigger && menu) {
      locationsDropdown.addEventListener('mouseenter', function () {
        menu.classList.remove('hidden');
      });
      locationsDropdown.addEventListener('mouseleave', function () {
        menu.classList.add('hidden');
      });
    }
  }

  /* ========================================================================
     Mobile Locations Dropdown (click)
     ======================================================================== */
  const mobileLocationsToggle = document.getElementById('mobile-locations-toggle');
  const mobileLocationsMenu = document.getElementById('mobile-locations-menu');
  const mobileLocationsChevron = document.getElementById('mobile-locations-chevron');

  if (mobileLocationsToggle && mobileLocationsMenu) {
    mobileLocationsToggle.addEventListener('click', function () {
      mobileLocationsMenu.classList.toggle('hidden');
      if (mobileLocationsChevron) {
        mobileLocationsChevron.classList.toggle('rotate-180');
      }
    });
  }

  /* ========================================================================
     Language Dropdown (desktop)
     ======================================================================== */
  const langToggle = document.getElementById('lang-toggle');
  const langMenu = document.getElementById('lang-menu');
  const langChevron = document.getElementById('lang-chevron');

  if (langToggle && langMenu) {
    langToggle.addEventListener('click', function () {
      langMenu.classList.toggle('hidden');
      if (langChevron) {
        langChevron.classList.toggle('rotate-180');
      }
    });

    document.addEventListener('click', function (e) {
      if (!langToggle.contains(e.target) && !langMenu.contains(e.target)) {
        langMenu.classList.add('hidden');
        if (langChevron) langChevron.classList.remove('rotate-180');
      }
    });
  }

  /* ========================================================================
     Accordion (Features, FAQ)
     ======================================================================== */
  document.querySelectorAll('[data-accordion-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      const parent = toggle.closest('[data-accordion-item]');
      if (!parent) return;

      const content = parent.querySelector('[data-accordion-content]');
      const chevron = toggle.querySelector('[data-accordion-chevron]');
      const isOpen = !content.classList.contains('hidden');

      /* Close all siblings first */
      const container = parent.closest('[data-accordion]');
      const isFeatures = container && container.querySelector('[data-accordion-index]');
      if (container) {
        container.querySelectorAll('[data-accordion-item]').forEach(function (item) {
          const c = item.querySelector('[data-accordion-content]');
          const ch = item.querySelector('[data-accordion-chevron]');
          if (c) c.classList.add('hidden');
          if (ch) ch.classList.remove('rotate-180');
          /* Reset features accordion styling */
          if (isFeatures) {
            item.style.height = '';
            item.style.background = '';
            var iconCircle = item.querySelector('[data-icon-circle]');
            if (iconCircle) iconCircle.style.background = 'rgba(148,85,255,0.15)';
            var btn = item.querySelector('[data-accordion-toggle]');
            if (btn) btn.style.paddingBottom = '';
          }
        });
      }

      /* Toggle current */
      if (!isOpen) {
        content.classList.remove('hidden');
        if (chevron) chevron.classList.add('rotate-180');
        /* Apply features accordion open styling */
        if (isFeatures) {
          parent.style.height = '188px';
          parent.style.background = 'hsl(264, 100%, 94%)';
          var iconCircle = parent.querySelector('[data-icon-circle]');
          if (iconCircle) iconCircle.style.background = '#fff';
          var btn = parent.querySelector('[data-accordion-toggle]');
          if (btn) btn.style.paddingBottom = '0';
        }
      }

      /* Update feature images if applicable */
      const index = toggle.getAttribute('data-accordion-index');
      if (index !== null) {
        updateFeatureImage(parseInt(index, 10), isOpen);
      }
    });
  });

  function updateFeatureImage(index, wasOpen) {
    const images = document.querySelectorAll('[data-feature-image]');
    images.forEach(function (img, i) {
      if (!wasOpen && i === index) {
        img.style.opacity = '1';
        img.style.zIndex = '10';
      } else {
        img.style.opacity = '0';
        img.style.zIndex = '0';
      }
    });
  }

  /* ========================================================================
     Reviews Carousel (desktop) — 2 visible cards + 2 peek cards
     ======================================================================== */
  document.querySelectorAll('[data-reviews-carousel]').forEach(function (carousel) {
    var isEnglish = !carousel.closest('[class*="fr-"]') && !document.querySelector('html[lang="fr"]');

    /* Determine language from page content */
    var centerText = carousel.querySelector('.text-h2');
    var isFrench = centerText && centerText.textContent.trim() === '5' &&
      carousel.textContent.indexOf('étoiles') > -1;

    var cdn = 'https://cdn.shopify.com/s/files/1/0747/7923/0527/files/';
    var reviews = isFrench ? [
      { name: 'Julie Brown', text: 'Nous avons eu une excellente expérience en utilisant le service pour la première fois ! Jon a fait un travail incroyable et notre chien Henry semblait passer un moment assez chill. J\'apprécie vraiment...', image: cdn + 'review-julie-brown.png' },
      { name: 'Lowdown Bass', text: 'Notre 2ème toilettage avec Mobispaw était exceptionnel ! Ce service et le propriétaire ont frappé un coup de circuit. Pas de stress, le van de toilettage mobile entièrement équipé se gare devant...', image: cdn + 'review-lowdown-bass.png' },
      { name: 'Sarah Mitchell', text: 'J\'adore absolument ce service ! Mon chien était si détendu et est ressorti magnifique. Le toiletteur était patient, doux et aime clairement les animaux. Je réserverai certainement à nouveau !', image: cdn + 'review-sarah-mitchell.png' },
      { name: 'Julie Brown', text: 'Nous avons eu une excellente expérience en utilisant le service pour la première fois ! Jon a fait un travail incroyable et notre chien Henry semblait passer un moment assez chill.', image: cdn + 'review-julie-brown-2.png' },
      { name: 'Emily Chen', text: 'Si pratique et professionnel ! Plus de trajets stressants en voiture chez le toiletteur. Notre chien de sauvetage anxieux était calme tout le temps. Les résultats étaient incroyables — merci !', image: cdn + 'review-emily-chen.jpg' }
    ] : [
      { name: 'Emily Chen', text: 'So convenient and professional! No more stressful car rides to the groomer. Our anxious rescue dog was calm the entire time. The results were incredible — thank you!', image: cdn + 'review-emily-chen.jpg' },
      { name: 'Julie Brown', text: 'We had a great experience using the service for the first time! Jon did an amazing job and our dog Henry seemed to have a pretty chill time. I really appreciate...', image: cdn + 'review-julie-brown.png' },
      { name: 'Lowdown Bass', text: 'Our 2nd groom with Mobispa was exceptional! This service & the owner has hit a home run with this. No stress, mobile fully equipped grooming van pull up in fron...', image: cdn + 'review-lowdown-bass.png' },
      { name: 'Sarah Mitchell', text: 'Absolutely love this service! My pup was so relaxed and came out looking amazing. The groomer was patient, gentle, and clearly loves animals. Will definitely book again!', image: cdn + 'review-sarah-mitchell.png' },
      { name: 'Julie Brown', text: 'We had a great experience using the service for the first time! Jon did an amazing job and our dog Henry seemed to have a pretty chill time. I really appreciate the convenience and will definitely be a repeat customer.', image: cdn + 'review-julie-brown-2.png' }
    ];

    var total = reviews.length;
    var currentIndex = 0;

    var leftCard = carousel.querySelector('[data-review-card="0"]');
    var rightCard = carousel.querySelector('[data-review-card="1"]');
    var peekLeftEl = carousel.querySelector('[data-peek-left]');
    var peekRightEl = carousel.querySelector('[data-peek-right]');
    var prevBtn = carousel.querySelector('[data-review-prev]');
    var nextBtn = carousel.querySelector('[data-review-next]');

    function renderCarousel() {
      var left = reviews[currentIndex];
      var right = reviews[(currentIndex + 1) % total];
      var peekL = reviews[(currentIndex - 1 + total) % total];
      var peekR = reviews[(currentIndex + 2) % total];

      /* Main cards */
      leftCard.style.background = 'linear-gradient(180deg, rgba(0,0,0,0) 58.3%, rgba(0,0,0,0.5) 72.21%, rgba(0,0,0,0.7) 100%), url(' + left.image + ') lightgray 50% / cover no-repeat';
      leftCard.querySelector('[data-review-text]').textContent = left.text;
      leftCard.querySelector('[data-review-name]').textContent = left.name;

      rightCard.style.background = 'linear-gradient(180deg, rgba(0,0,0,0) 58.3%, rgba(0,0,0,0.5) 72.21%, rgba(0,0,0,0.7) 100%), url(' + right.image + ') lightgray 50% / cover no-repeat';
      rightCard.querySelector('[data-review-text]').textContent = right.text;
      rightCard.querySelector('[data-review-name]').textContent = right.name;

      /* Peek cards */
      if (peekLeftEl) {
        peekLeftEl.querySelector('img').src = peekL.image;
        peekLeftEl.querySelector('p').textContent = peekL.text.slice(0, 30) + '...';
      }
      if (peekRightEl) {
        var prImg = peekRightEl.querySelector('[data-peek-right-img]');
        var prTxt = peekRightEl.querySelector('[data-peek-right-text]');
        if (prImg) prImg.src = peekR.image;
        if (prTxt) prTxt.textContent = peekR.text.slice(0, 30) + '...';
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        currentIndex = (currentIndex - 1 + total) % total;
        renderCarousel();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        currentIndex = (currentIndex + 1) % total;
        renderCarousel();
      });
    }

    renderCarousel();
  });

  /* ========================================================================
     Contact Form Validation
     ======================================================================== */
  // const contactForm = document.getElementById('contact-form');
  // if (contactForm) {
  //   contactForm.addEventListener('submit', function (e) {
  //     e.preventDefault();
  //     /* Basic validation */
  //     const inputs = contactForm.querySelectorAll('[required]');
  //     let valid = true;
  //     inputs.forEach(function (input) {
  //       if (!input.value.trim()) {
  //         valid = false;
  //         input.style.borderColor = 'hsl(0, 84.2%, 60.2%)';
  //       } else {
  //         input.style.borderColor = '';
  //       }
  //     });
  //     if (valid) {
  //       /* Submit form — configure endpoint as needed */
  //       alert('Form submitted successfully!');
  //       contactForm.reset();
  //     }
  //   });
  // }

  function validateEmail(email) {
    // Regular expression for a simple email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Test the email against the regular expression
    return emailRegex.test(email);
  }

 $(document).ready(function () {
  
  $("#contact-form").submit(async (event) => {
    event.preventDefault();
    const name = $("#contact-name").val();
    const email = $("#contact-email").val();
    const phone = $("#contact-phone").val();
    const message = $("#contact-message").val();
    if(!name || name.length === 0) {
      return $("#name-error").text("Insert full name")
    } else {
      $("#name-error").text("")
    }
    if(!validateEmail(email)) {
      return $("#email-error").text("Insert valid email")
    } else {
      $("#email-error").text("")
    }
     if(!phone || phone.length === 0) {
      return $("#phone-error").text("Insert phone number")
    } else {
      $("#phone-error").text("")
    }
    const jsonData = {
      name,
      email,
      message,
      phone
    };
    $("#contact-button").text("Sending...")
    $("#contact-button").prop('disabled', true);
    const { data: response } = await fetch("https://mobispaw-email.vercel.app/api/quote", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(jsonData),
    });
     $("#contact-button").text("Sent!")
     $("#contact-button").prop('disabled', false)
    $("#contact-name").val("");
    $("#contact-email").val("");
    $("#contact-phone").val("");
    $("#contact-message").val("")
    setTimeout(() => {
       $("#contact-button").text("Submit")
    }, 2000)
    console.log(response);
  });
});

  /* ========================================================================
     Smooth scroll for #book links
     ======================================================================== */
  document.querySelectorAll('a[href="#book"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.getElementById('book');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

});
